import React, { useEffect, useState, Suspense } from 'react';
import { useRoutes, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';

import ClassicHomepage from './pages/pages/Homepage/ClassicHomepage';
import ModernHomepage from './pages/pages/Homepage/ModernHomepage';
import customHomepages from './pages/pages/Homepage/custom';
import AddBooking from './pages/pages/AddBooking/AddBooking';
import Loader from './pages/pages/Components/Loader';
import { useUser } from './contexts/UserContext';
import ErrorScreen from './pages/pages/Components/ErrorScreen';

const getSubdomain = () =>
    process.env.REACT_APP_TEST_ENV && process.env.REACT_APP_TEST_ENV_SUBDOMAIN
        ? process.env.REACT_APP_TEST_ENV_SUBDOMAIN
        : window.location.hostname.split('.')[0];

const App = () => {
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const { user, setUser } = useUser();
    const searchParams = new URLSearchParams(location.search);
    const styleParam = searchParams.get('st');

    const useModern =
        styleParam === 'm' || (!styleParam && user?.portal?.website_style === 2);

    const subdomain = getSubdomain();
    // An explicit ?st= param bypasses the custom homepage so the regular
    // website stays reachable for comparison.
    const CustomHomepage = !styleParam && customHomepages[subdomain];

    let routes = [
        {
            path: '/',
            element: CustomHomepage ? (
                <Suspense fallback={<Loader />}>
                    <CustomHomepage />
                </Suspense>
            ) : useModern ? (
                <ModernHomepage />
            ) : (
                <ClassicHomepage user={user} />
            ),
        },
        {
            path: '/book',
            element: <AddBooking />,
        },
        {
            path: '*',
            element: <Navigate replace to='/' />,
        },
    ];

    async function getData(subdomain) {
        const res = await fetch(
            `https://bestmate.us/portal/profile/${subdomain}?websiteDetails=true`
        );

        if (!res.ok) {
            setLoading(false);
        }
        let data = await res.json();
        setUser(data);
        setLoading(false);
    }

    useEffect(() => {
        getData(getSubdomain());
    }, []);

    const content = useRoutes(routes);
    return (
        <HelmetProvider>
            <Helmet
                title={`${
                    user && user.business && user.business.business_name
                        ? user.business.business_name
                        : user &&
                          user.business &&
                          user.business.business_user_name
                        ? user.business.business_user_name
                        : 'Bestmate'
                }`}
            />
            {loading ? (
                <Loader />
            ) : user && user.length !== 0 ? (
                content
            ) : (
                <ErrorScreen />
            )}
        </HelmetProvider>
    );
};

export default App;
